import * as jose from 'jose';

const SECOND = 60;
const MINUTE = 15;
const EXPIRED_TIME = SECOND * MINUTE;

const HEADER = { alg: 'HS256', typ: 'JWT' };

const DEFAULT_PAYLOAD = {
  iss: 'anywhere-app.learn.co.th',
  aud: 'game.learn.co.th',
  sub: '', // classroom account id
  sid: '', // School Id
  un: '', // UserId (same as sub)
  cid: '', // Course Code
  t: 65, // study year semester (Hard code)
};

export const generateGamificationUrl = async (payload, secret, gamificationBaseUrl) => {
  if (!secret) return;
  const EncodedSecret = new TextEncoder().encode(secret);
  const generatedJwt = await new jose.SignJWT({
    ...DEFAULT_PAYLOAD,
    ...payload,
    iat: Math.floor(Date.now() / 1000), // issue at in unix timestamp
    exp: Math.floor(Date.now() / 1000) + EXPIRED_TIME,
  })
    .setProtectedHeader(HEADER)
    .sign(EncodedSecret);

  const gamificationUrl = gamificationBaseUrl + generatedJwt;

  return gamificationUrl;
};

const NON_ALPHABETIC_CHARACTER = /[^a-zA-Z]/g;

/**
 * @param {string} userName
 * @returns {string}
 */
export const getSchoolIdFromUserName = (userName) => {
  // username pattern: learned.xxxNNNNNN
  // x: school name
  // N: number
  const dotIndex = userName.indexOf('.');
  /**
   * userSchoolName can be: 'MHG'(normal user) or 'MHGD'(dummy user for testing system)
   * 1.sub string 3 char (ignore is there are dummy user or not )
   * 2.check if extractedUserSchoolName is included in pilotGamificationSchoolNameArray
   */
  const schoolName = userName
    .substring(dotIndex + 1)
    .replace(NON_ALPHABETIC_CHARACTER, '')
    .slice(0, 3); //Extract the characters from the index after the dotIndex (dotIndex + 1) and remove all non-alphabetic characters
  return schoolName;
};

/**
 * @param {string[]} pilotGamificationSchoolNameArray
 * @param {string} userSchoolName
 * @returns {boolean}
 */
const checkIfUserSchoolAreInPilotSchool = (pilotGamificationSchoolNameArray, userSchoolName) => {
  if (!pilotGamificationSchoolNameArray.includes(userSchoolName)) {
    return false;
  } else {
    return true;
  }
};

/**
 * @param {string[]} pilotGamificationSchoolNameArray
 * @param {string} providerName
 * @param {string} userSchoolName
 * @returns {boolean}
 */
export const validateIsGamificationUser = (
  pilotGamificationSchoolNameArray,
  providerName,
  userSchoolName
) => {
  if (pilotGamificationSchoolNameArray === []) return false; //handle is there are no config provided.

  const isLearnEdUser = providerName === 'learned';

  if (!isLearnEdUser) {
    return false;
  }
  const isGamificationUser = checkIfUserSchoolAreInPilotSchool(
    pilotGamificationSchoolNameArray,
    userSchoolName
  );
  return isGamificationUser;
};
